import styled from 'styled-components'
// import { media } from '../../../utils'

const CustomFormContainer = styled.div`
  position: relative;
  grid-area: content;
  align-self: center;
  max-width: 100%;
  min-height: 310px;

  margin: 0px auto;
  padding: 0 10px;
  width: 100%;

  h2 {
    font-family: 'Montserrat', Sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }

  h3 {
    font-family: 'Montserrat', Sans-serif;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 15px;
    color: #6bcf74;
    text-align: center;
    i {
      font-size: 14px;
      margin-right: 10px;
    }
  }
  label {
    font-weight: 700;
    color: #4a4a4a;
    margin: 10px 5px 2px;
    padding: 0px;
    font-size: 16px;
  }
`

export default CustomFormContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/CustomFormContainer.tsx